export const calculatePageCount = (count, pageSize) =>
  Math.trunc(count / pageSize + (count % pageSize !== 0));
